const t = "ids-tab-set-v501", s = "ids-tab-set--list-v501", e = "ids-tab-set--panel-v501", a = "ids-tab-set--list-item-v501", i = {
  tabSet: t,
  list: s,
  "layout--top-left": "ids-tab-set--layout--top-left-v501",
  "layout--top-center": "ids-tab-set--layout--top-center-v501",
  "layout--top-right": "ids-tab-set--layout--top-right-v501",
  panel: e,
  "ids-badge": "ids-badge-v501",
  listItem: a
};
export {
  i as s
};
